import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector, connect } from "react-redux";

// REDUX ACTIONS
import { logout } from "../../../redux/actions/auth";
// CSS STYLES
import styles from '../../../styles/layouts/DashboardHeaderBar.module.css'
// ICONS
import { FaPowerOff } from "react-icons/fa6";




function UserDropdown({ logout }) {

    const navigate = useNavigate();

    const auth = useSelector((state) => state.auth);

    const handleSignOut = async () => {
        await logout();
        navigate("/");
    };
    

    const redirectTo = (type) => {
        if (type === 'profile') {
            window.location.replace(`${process.env.REACT_APP_DPS_CMS_URL}/admin/profile`);
            
        } else if (type === 'users') {
            window.location.replace(`${process.env.REACT_APP_DPS_CMS_URL}/admin/users`);
        } else if (type === 'roles') {
            window.location.replace(`${process.env.REACT_APP_DPS_CMS_URL}/admin/roles`);
        }
    }

  return auth.accountUser?.hasAccess && (
    <>
        <div className={styles.userDropdown_main_wrapper}>
            
            {/* POWER BUTTON ICON */}
            <div className={styles.power_btn_container}>
                <FaPowerOff size={20}/>
            </div>

            {/* HOVER MENU */}
            <div className={styles.edit_options}>
                <div>
                    <p onClick={() => redirectTo('profile')}>Profile</p>
                </div>
                <div>
                    <p onClick={() => redirectTo('users')}>Manage Users</p>
                </div>
                <div>
                    <p onClick={() => redirectTo('roles')}>Manage Roles</p>
                </div>
                <div>
                    <p onClick={handleSignOut}>Sign Out</p>
                </div>
            </div>
        </div>


    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(UserDropdown);